import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withKeys as _withKeys, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "py-16 md:py-24 bg-slate-50/40" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-6 lg:px-10 xl:px-14" }
const _hoisted_3 = { class: "grid lg:grid-cols-12 gap-10 lg:gap-16 items-start" }
const _hoisted_4 = { class: "lg:col-span-6 w-full order-1 lg:order-2" }
const _hoisted_5 = { class: "rounded-2xl bg-white/80 supports-[backdrop-filter]:backdrop-blur-md shadow-xl ring-1 ring-black/5 p-6 md:p-8" }
const _hoisted_6 = { class: "mt-2 flex items-center rounded-xl border border-slate-200 bg-white/95 focus-within:ring-2 focus-within:ring-emerald-500/30 focus-within:border-emerald-400 transition" }
const _hoisted_7 = { class: "mt-2 flex items-center rounded-xl border border-slate-200 bg-white/95 focus-within:ring-2 focus-within:ring-emerald-500/30 focus-within:border-emerald-400 transition" }
const _hoisted_8 = ["type"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_11 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_12 = { class: "flex flex-col md:flex-row md:items-center gap-3 md:gap-4 pt-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "inline-flex items-center gap-2"
}
const _hoisted_16 = { class: "text-center text-slate-500 text-sm mt-4" }

import { ref } from 'vue'
import TopBanner from '@/components/TopBanner.vue'
import { NotificationType } from '@/types/index'
import Auth from '@/composables/Auth'
import { handleApiError, saveAuthCredentials } from '@/utils/common'
import Notification from '@/widgets/Notification.vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const passwordFieldtype = ref<'password' | 'text'>('password')
const email = ref<string>('')
const password = ref<string>('')
const isLoading = ref<boolean>(false)
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})
const { loginUser }  = Auth()
const router = useRouter()

const togglePasswordFieldType = () :void => {
  passwordFieldtype.value = passwordFieldtype.value === 'password' ? 'text' : 'password'
}

const handleLogin = async () : Promise<void> => {
  if (email.value !== '' && password.value !== '' && !isLoading.value) {
    isLoading.value = true
    const response = await loginUser(email.value, password.value)
    isLoading.value = false

    if (response.status === 200) {
      const accountType = saveAuthCredentials(response.data)
      if (accountType === 'agent' || accountType === 'corporate') {
        router.push({ name: 'AccountDashboard' })
      } else if (accountType === 'web') {
        router.push({ name: 'UserSettings', params: { userType: 'web' } })
      } else {
        router.push({ name: 'Home' })
      }
    } else {
      const error = handleApiError(response)
      notif.value = { show: true, type: 'error', message: error, messageDetails: '' }
      setTimeout(() => { notifClosed() }, 4000)
    }
  }
}

const notifClosed = () : void => {
  notif.value.show = false
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopBanner, {
      layout: "full-width",
      currentPage: "Login",
      heading: "Login",
      bannerClass: "banner-auth"
    }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"lg:col-span-6 space-y-8 lg:pr-6 order-2 lg:order-1\"><div><span class=\"inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-200/50 uppercase tracking-widest\"> Trusted Global Network </span><h2 class=\"text-3xl md:text-4xl font-extrabold text-slate-900 mt-4 leading-tight\"> Your Premium Chauffeur Service Partner </h2><p class=\"text-slate-600 mt-4 text-[16px] leading-relaxed\"> Welcome back to Vehitra World. Sign in to your portal to manage your chauffeur bookings, download Statements of Account, track vehicle routes, and book premium ground transportation worldwide. </p></div><div class=\"space-y-6\"><h3 class=\"text-xs uppercase tracking-[0.2em] font-bold text-slate-400\">Why Travel With Us</h3><div class=\"flex gap-4\"><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center border border-emerald-100 shadow-sm\"><i class=\"pi pi-shield text-lg\"></i></div><div><h4 class=\"text-[16px] font-bold text-slate-800\">Safety &amp; Compliance First</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\">All rides are backed by fully-insured vehicles and professional, local chauffeurs trained in executive client service.</p></div></div><div class=\"flex gap-4\"><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center border border-emerald-100 shadow-sm\"><i class=\"pi pi-map-marker text-lg\"></i></div><div><h4 class=\"text-[16px] font-bold text-slate-800\">Global Reach, Consistent Quality</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\">Access clean, premium Mercedes-Benz, BMW, and executive SUVs with identical service quality in every major destination.</p></div></div><div class=\"flex gap-4\"><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center border border-emerald-100 shadow-sm\"><i class=\"pi pi-phone text-lg\"></i></div><div><h4 class=\"text-[16px] font-bold text-slate-800\">24/7 Operations Support</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\">Our operations room monitors every flight and coordinates with chauffeurs globally to guarantee a flawless transfer.</p></div></div></div></div>", 1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "text-slate-800 text-2xl md:text-3xl font-semibold tracking-tight" }, " Welcome back ", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-slate-500 mt-1 text-sm" }, " Sign in to continue to your account. ", -1)),
              _createElementVNode("form", {
                class: "mt-8 space-y-6",
                onSubmit: _withModifiers(handleLogin, ["prevent"])
              }, [
                _createElementVNode("div", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", {
                    for: "login-username",
                    class: "block text-[12px] uppercase tracking-widest text-slate-500"
                  }, " Username or email address * ", -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "pl-3 pr-2 text-slate-400" }, [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          d: "M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z",
                          stroke: "#64748b",
                          "stroke-width": "2"
                        }),
                        _createElementVNode("path", {
                          d: "M22 6l-10 7L2 6",
                          stroke: "#64748b",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ])
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                      id: "login-username",
                      type: "text",
                      autocomplete: "username",
                      class: "flex-1 h-12 md:h-[52px] bg-transparent outline-none text-slate-800 placeholder-slate-400 px-2 md:px-3 text-[15px]",
                      placeholder: "you@example.com"
                    }, null, 512), [
                      [_vModelText, email.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", {
                    for: "login-password",
                    class: "block text-[12px] uppercase tracking-widest text-slate-500"
                  }, " Password * ", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "pl-3 pr-2 text-slate-400" }, [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "none"
                      }, [
                        _createElementVNode("rect", {
                          x: "3",
                          y: "11",
                          width: "18",
                          height: "10",
                          rx: "2",
                          stroke: "#64748b",
                          "stroke-width": "2"
                        }),
                        _createElementVNode("path", {
                          d: "M7 11V8a5 5 0 0110 0v3",
                          stroke: "#64748b",
                          "stroke-width": "2",
                          "stroke-linecap": "round"
                        })
                      ])
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                      type: passwordFieldtype.value,
                      id: "login-password",
                      autocomplete: "current-password",
                      class: "flex-1 h-12 md:h-[52px] bg-transparent outline-none text-slate-800 placeholder-slate-400 px-2 md:px-3 text-[15px]",
                      placeholder: "••••••••",
                      onKeydown: _withKeys(handleLogin, ["enter"])
                    }, null, 40, _hoisted_8), [
                      [_vModelDynamic, password.value]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "pr-3 pl-2 text-slate-500 hover:text-slate-700 transition",
                      onClick: togglePasswordFieldType,
                      "aria-label": passwordFieldtype.value === 'password' ? 'Show password' : 'Hide password'
                    }, [
                      (passwordFieldtype.value === 'password')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[5] || (_cache[5] = [
                            _createElementVNode("path", {
                              d: "M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z",
                              stroke: "#64748b",
                              "stroke-width": "2"
                            }, null, -1),
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "3",
                              stroke: "#64748b",
                              "stroke-width": "2"
                            }, null, -1)
                          ])))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[6] || (_cache[6] = [
                            _createElementVNode("path", {
                              d: "M1 1l22 22",
                              stroke: "#64748b",
                              "stroke-width": "2"
                            }, null, -1),
                            _createElementVNode("path", {
                              d: "M3 3l3.59 3.59C4.22 8.29 2.62 10.03 1 12c0 0 4 7 11 7 2.11 0 4.03-.5 5.73-1.32L21 21",
                              stroke: "#64748b",
                              "stroke-width": "2",
                              "stroke-linecap": "round"
                            }, null, -1),
                            _createElementVNode("path", {
                              d: "M9.88 9.88A3 3 0 0012 15a3 3 0 002.12-.88",
                              stroke: "#64748b",
                              "stroke-width": "2",
                              "stroke-linecap": "round"
                            }, null, -1)
                          ])))
                    ], 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "order-2 md:order-1 w-full md:w-auto rounded-full px-5 md:px-7 py-3 border-2 border-slate-200 text-slate-700 hover:bg-white uppercase tracking-wide text-xs md:text-[12px] font-medium transition",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'ForgetPassword' }))),
                    type: "button"
                  }, " Lost your password "),
                  _createElementVNode("button", {
                    class: "order-1 md:order-2 w-full md:w-auto rounded-full px-6 md:px-8 py-3 border-2 border-emerald-600 bg-emerald-600 text-white uppercase tracking-wide text-xs md:text-[12px] font-semibold shadow hover:bg-white hover:text-emerald-700 transition disabled:opacity-40 disabled:cursor-not-allowed",
                    disabled: isLoading.value || !email.value || !password.value,
                    type: "submit"
                  }, [
                    (!isLoading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Login"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _cache[9] || (_cache[9] = [
                          _createElementVNode("svg", {
                            class: "animate-spin",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M12 2a10 10 0 100 20",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round"
                            })
                          ], -1),
                          _createTextVNode(" Processing… ")
                        ])))
                  ], 8, _hoisted_13)
                ])
              ], 32)
            ]),
            _createElementVNode("p", _hoisted_16, [
              _cache[13] || (_cache[13] = _createTextVNode(" Need an account? ")),
              _createVNode(_component_router_link, {
                to: "/signup/web",
                class: "text-emerald-700 hover:underline"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("Sign up")
                ])),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"])
  ], 64))
}
}

})